import axios from 'axios';
import { message } from 'antd';
import { handleBusinessUnauthorized, handleUnauthorized } from '../utils/auth-guard';

const request = axios.create({
  baseURL: '/api',
  timeout: 30000,
});

/** 统一从 Zustand persist 中读取 token */
const getToken = () => {
  try {
    const raw = localStorage.getItem('simon-cat-auth');
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed?.state?.token || null;
  } catch {
    return null;
  }
};

// 错误去重：避免多个API失败时堆叠显示错误消息
let lastErrorTime = 0;
const ERROR_THROTTLE_MS = 3000; // 3秒内只显示一次错误

request.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

request.interceptors.response.use(
  (response) => {
    const { data } = response;
    // ApiResult 格式：{ code: 200, message: "success", data: T }
    if (data && data.code !== undefined) {
      // 业务码形式未登录：写操作提示登录，读操作静默（控制台允许匿名浏览）
      if (data.code === 401) {
        handleBusinessUnauthorized(response.config);
        return Promise.reject(new Error(data.message || '未登录'));
      }
      if (data.code !== 200 && data.code !== 0) {
        message.error(data.message || '请求失败');
        return Promise.reject(new Error(data.message));
      }
      // 返回 data.data 即 LoginResponse 等业务数据
      return data.data;
    }
    // 非 ApiResult 格式直接返回
    return data;
  },
  (error) => {
    if (error.response?.status === 401) {
      // 不再整页跳转登录页：只读请求静默，写操作（POST 等）提示用户登录
      handleUnauthorized(error);
      return Promise.reject(error);
    }
    // 节流错误消息，避免堆叠
    const now = Date.now();
    if (now - lastErrorTime > ERROR_THROTTLE_MS) {
      lastErrorTime = now;
      message.error(error.response?.data?.message || '网络错误');
    }
    return Promise.reject(error);
  }
);

export default request;